export const RocketIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Rocket Icon</title>
      <path
        d="M9.0426 14.7076C13.8443 13.3884 17.8459 9.28758 18.5018 1.66675C10.8809 2.32175 6.77927 6.32341 5.46094 11.1259L9.04344 14.7084L9.0426 14.7076Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.83675 14.125C3.57842 14.2525 3.32008 14.435 3.07175 14.6833C2.10425 15.6508 1.83508 18.3333 1.83508 18.3333C1.83508 18.3333 4.51842 18.0633 5.48508 17.0967C5.73258 16.8492 5.91508 16.59 6.04342 16.3317"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0851 7.50008C13.3152 7.50008 13.5018 7.31353 13.5018 7.08341C13.5018 6.8533 13.3152 6.66675 13.0851 6.66675C12.855 6.66675 12.6685 6.8533 12.6685 7.08341C12.6685 7.31353 12.855 7.50008 13.0851 7.50008Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3351 11.6658V14.1974C14.3351 14.7041 14.1043 15.1833 13.7084 15.4999L9.9501 18.5016L9.0426 14.7074"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50258 5.83325H5.97091C5.46425 5.83325 4.98508 6.06409 4.66841 6.45992L1.66675 10.2183L5.46091 11.1258"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
